/**
 * skip-link-focus-fix
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
( function() {
	var isIe = /(trident|msie)/i.test( navigator.userAgent );

	if ( isIe && document.getElementById && window.addEventListener ) {
		window.addEventListener( 'hashchange', function() {
			var id = location.hash.substring( 1 ),
				element;

			if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
				return;
			}

			element = document.getElementById( id );

			if ( element ) {
				if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
					element.tabIndex = -1;
				}

				element.focus();
			}
		}, false );
	}
} )();


/**
 * custom theme styles
 *
 */

var $ = jQuery;

$(window).load(function(){
  // Blogpost subscribe
  if($('.st-blogpost-wrap').length){
    const entryContentHeight = $('.st-blogpost-wrap .entry-content').outerHeight(true);

    if(entryContentHeight - 140 > $(window).height()) {
      $('.st-blogpost--subscribe').addClass('long-enough');
    }
  };

});



$(() => {
  $('#menu-main-nav a').click(function() {
    $('body').addClass('hideAll');
  });

  $('#mobile-nav-icon').click(function() {
    $(this).toggleClass('open');
    $('header nav').toggleClass('visible');
  });

  $('#remote-menu-trigger').click(function() {
    $('#menu-trigger').click();
  });

  // Load more posts
  $('.st-load-more--btn').click(function(){
 
		var button = $(this),
		    data = {
			'action': 'loadmore',
			'query': simplethread_2019_loadmore_params.posts, // that's how we get params from wp_localize_script() function
			'page' : simplethread_2019_loadmore_params.current_page
    };
 
		$.ajax({
			url : simplethread_2019_loadmore_params.ajaxurl,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...');
			},
			success : function( data ){
				if( data ) { 
          // button.text( 'More Posts &amp; Essays' ).before(data).slideDown();
          button.text( 'More Posts & Essays' );
          $(data).insertBefore(button).hide().slideDown('fast');
					simplethread_2019_loadmore_params.current_page++;
 
					if ( simplethread_2019_loadmore_params.current_page == simplethread_2019_loadmore_params.max_page ) 
						button.remove(); 
				} else {
					button.remove();
				}
			}
		});
  });
  
  // hover related link 

  $( ".st-hover-trigger" ).hover(
    function() {
      var sharedParent = $(this).data('shared-parent');
      $( this ).closest('.'+sharedParent).addClass('st-shared-hover');
    }, function() {
      var sharedParent = $(this).data('shared-parent');
      $( this ).closest('.'+sharedParent).removeClass('st-shared-hover');
    }
  );

  // Transform legacy pre tags to Prism.js
  $('pre[class^="brush:"]').each((idx, elem) => {
    const $elem = $(elem);
    const snippet = $elem.html();
    const language = $elem.attr('class').match(/brush: (.+);/)[1];

    const $code = $('<code/>').html(snippet);

    if (language) $code.addClass(`language-${language}`);

    $elem
      .empty()
      .removeAttr('class')
      .append($code);
  });
  
  // handle noOrphans

  function removeNbsps($noOrphans) {
    $noOrphans.each(function () {
      $(this).html(function (i, html) {
        return html.replace(/&nbsp;/g, ' ');
      });
    });
  }

  function checkWindowWidth() {
    const windowWidth = window.innerWidth || document.body.clientWidth;

    if(windowWidth < 760) {
      const $noOrphans = $('.st-no-orphan');
      removeNbsps($noOrphans);
    }
  }

  checkWindowWidth();

  $(window).on('resize', function() {
    checkWindowWidth();
  });

}); //End Document Ready Function



$(document).ready(function(){

// ======================================================================
// Home - Scroll Out
// ======================================================================

ScrollOut({
  targets: ".home-hero__img, .home-hero-sec__content, .home-hero__thread, .home-img-text__img-wrap, .cs-hca-solution__img-wrap",
  threshold: 0.1,
  cssProps: {
      viewportY: true
  }
});

ScrollOut({
  threshold: 0.2
});



// ======================================================================
// Slider
// ======================================================================

if ( $('.st-image-slider').length ) {
  $('.st-image-slider').slick({
    'arrows': false,
    'adaptiveHeight': true,
    'dots': true,
    'slide': 'img'
  });
}




// ======================================================================
// Select
// ======================================================================
window.addEventListener('message', event => {
  if ( event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady' ) {

    if ( $('.hs-form select').length ) {
      $('.hs-form select').wrap('<span class="st-select-wrap"></span>').addClass('st-select--wrapped');
    }
    
  }
});



// ======================================================================
// external links
// ======================================================================
function externalLinksTarget() {
  const elsLinks = document.querySelectorAll('a:not([href^="#"]):not([href^="/"]):not([href^="tel:"]):not([href^="mailto:"]):not([href*="' + window.location.hostname + '"]):not([target="_blank"])');
  
  elsLinks.forEach((el) => {
    el.setAttribute('target', '_blank');
  });
}
externalLinksTarget();



// ======================================================================
// Components parent class
// ======================================================================
if ( $('.components').length ) {
  const $lastChild = $('.components').children().last();

  if ( $lastChild.hasClass('component--solid') ) {
    $('.components').addClass('last-child-solid');
  }
}



});